import PostHogPageView from "@/lib/postHog/PostHogPageView";
import "@fontsource/poppins";
import { Box, CssBaseline } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import SideBar from "./components/layout/SideBar";
import { useAppSelector } from "./hooks";
import Router from "./router/router";

function App() {
  const isLogged = useAppSelector((state) => state.login.isConnected);
  const posthog = usePostHog();

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {isLogged ? <SideBar /> : null}

      <Router />

      <ToastContainer />
      <PostHogPageView posthog={posthog} />
    </Box>
  );
}

export default App;
